import { Injectable } from '@angular/core';
import { Location } from '@angular-material-extensions/google-maps-autocomplete';
import { IMap } from '../interfaces/map';
import { ITravelMode } from '../interfaces/travel-mode';
import { IRoute } from '../interfaces/route';
import { JourneyService } from './journey.service';

@Injectable({
  providedIn: 'root'
})
export class MapsService {
  private routes: { [route: string]: IRoute } = this.journeyService.routes;
  private maps: {[mode: string]: IMap} = {};
  private origins: {[mode: string]: Location} = {};
  private hasMap: {[mode: string]: boolean} = {};
  private mapInstances: {[mode: string]: any} = {};
  private selectedMap: ITravelMode;
  public detectChanges: Function;

  constructor(
    private journeyService: JourneyService,
  ) { }

  clearMap(mode: ITravelMode) {
    this.maps[mode] = null;
    this.origins[mode] = null;
    this.hasMap[mode] = false;
    this.detectChanges();
  }

  setMap(mode?: ITravelMode) {
    if (this.journeyService.hasRoute()) {

      if (mode && this.routes && this.routes[mode] && !this.routes[mode].available) { return; }

      this.clearMap(mode);

      let travelMode: ITravelMode;

      if (mode) {
        travelMode = mode;
      } else if ((this.routes.BICYCLING && this.routes.BICYCLING.available)) {
        travelMode = 'BICYCLING';
      } else {
        const availableRoutes = Object.values(this.routes).filter(r => r.available);
        travelMode = availableRoutes.reduce((p: any, n: any) => p.cals > n.cals ? p.mode : n.mode) as any;
      }

      this.selectedMap = travelMode;
      this.journeyService.setMap(travelMode);
      this.maps[travelMode] = this.journeyService.map;

      const sameLocation = this.maps[travelMode].destination === this.maps[travelMode].origin;

      this.origins[travelMode] = this.journeyService.origin;
      this.hasMap[travelMode] = true;
      this.detectChanges();
      this.setMapLayer(travelMode);
      return {
        sameLocation,
        data: this.maps,
        origins: this.origins,
        hasMap: this.hasMap,
        selectedMap: this.selectedMap,
      };
    }
  }

  onMapReady(instance: any, mode: ITravelMode) {
    this.mapInstances[mode] = instance;
    this.journeyService.updateFlights();
    this.setMapLayer(mode);
  }

  setMapLayer(mode: ITravelMode) {
    if (this.mapInstances[mode]) {

      const trafficLayer = new google.maps.TrafficLayer();
      const transitLayer = new google.maps.TransitLayer();
      trafficLayer.setMap(null);
      transitLayer.setMap(null);

      if (mode === 'DRIVING') {
        trafficLayer.setMap(this.mapInstances[mode]);
      } else if (mode === 'TRANSIT') {
        transitLayer.setMap(this.mapInstances[mode]);
      }
    }
  }
}
